var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallToSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 133,
    viewBox: "0 0 126 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23885_22152",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 126,
    height: 133
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.117615H125.521V133H0V0.117615Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23885_22152)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3689 121.475C23.8699 115.296 15.147 106.506 9.04694 95.9587C8.61362 95.2084 8.19655 94.4445 7.78761 93.6725C2.86133 84.3815 0.1206 74.0909 0.00956208 63.7028C-0.014812 62.5624 0.00956208 61.395 0.0583103 60.2356C0.472399 50.5651 3.25294 41.1437 8.15593 32.7986C26.404 1.70206 65.7032 -9.18715 96.3523 8.80984C127.001 26.8068 133.707 75.5645 115.475 106.661C97.2433 137.758 65.0099 139.459 34.3689 121.475Z",
    fill: "#C7EAFB"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.3432 42.6211C87.3837 52.983 77.0612 48.5514 67.9508 53.6835C59.5393 58.4217 51.7722 45.728 51.7722 35.3109C51.7722 24.8937 53.9058 14.0001 63.3514 14.0001C72.797 14.0001 88.7692 38.0187 88.3432 42.6211Z",
    fill: "#694A52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9683 63.5504L55.1188 64.3931L60.7237 41.7288L68.6103 39.7455L74.9683 63.5504Z",
    fill: "#FFDFAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4605 119.27H73.749V57.2425C62.106 71.4695 56.5748 57.2425 56.5748 57.2425L50.4605 119.27Z",
    fill: "#E0F5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6693 117.865C63.1141 109.55 70.2112 98.1686 70.2887 86.3937C70.3088 83.3438 71.3484 78.5829 71.5762 75.5416C71.7963 72.6047 72.2283 66.4826 72.892 63.6382C73.5343 60.8898 71.8447 53.2639 71.7552 51.5165C73.616 52.0068 73.8327 52.3194 76.3667 53.2511C81.9822 55.3153 87.9703 56.2188 88.3535 58.7125C89.6196 66.9134 82.7529 99.6921 82.7529 99.6921L88.5132 119.27C88.5132 119.27 74.3855 121.954 70.6693 117.865Z",
    fill: "#ADADEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2139 51.8804C52.9991 53.7879 47.5386 58.5964 44.9177 62.0847C44.8999 62.1084 44.8275 62.1897 44.7083 62.3234C43.0691 64.1633 32.591 75.9236 34.1597 83.9213C35.0653 88.5371 45.0046 99.6594 48.2339 103.177C48.0151 112.287 47.7201 119.272 47.7201 119.272C47.7201 119.272 50.925 120.077 52.8462 119.7C58.0823 118.673 56.9424 109.08 55.904 100.342C55.5042 96.9777 55.1194 93.7398 55.1194 91.1661C55.1199 88.1335 55.574 80.3496 55.9765 73.4494C56.2529 68.7123 56.5049 64.3917 56.5692 62.3108C56.7118 57.7036 58.2139 51.8804 58.2139 51.8804ZM48.1931 72.0141C48.507 78.379 48.5117 86.7781 48.3982 94.7285L41.9939 82.4942L48.1931 72.0141Z",
    fill: "#9499EA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9827 74.0378L58.1234 73.0988C58.6221 73.0426 59.0764 73.3898 59.1532 73.8858L61.8365 85.0184C62.0078 85.7373 61.5462 86.4485 60.9202 86.425L55.9735 86.2387C55.5597 86.1994 55.2181 85.8984 55.127 85.4928L52.2496 75.4851C52.1478 75.1961 52.1684 74.8781 52.3069 74.6048C52.4453 74.3315 52.6895 74.1266 52.9827 74.0378Z",
    fill: "#30312C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1698 85.7823C56.8715 87.6068 62.4044 90.0799 62.4044 90.0799L63.8247 86.0229C63.8247 86.0229 61.167 80.7598 59.471 81.3939C58.4066 81.7938 55.73 84.6382 56.1698 85.7823Z",
    fill: "#FFECB3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4149 89.6556C61.4149 89.6556 84.1699 103.946 87.6622 100.277C94.7361 92.8519 88.3507 58.7133 88.3507 58.7133C82.6987 57.4494 81.9794 71.834 81.9794 71.834C81.9794 71.834 81.9272 85.4397 82.5668 89.7631L63.8945 85.8341L61.4149 89.6556Z",
    fill: "#9499EA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.349 45.9171C58.349 45.9171 64.5527 40.8897 68.6679 39.9135C68.6679 39.9135 69.5429 43.2962 70.555 47.0102C69.2766 49.8156 63.2538 52.6901 60.6735 53.0258C58.5875 53.2968 58.349 45.9171 58.349 45.9171Z",
    fill: "#F4CA92"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6694 38.4446C70.6694 31.1001 67.2316 26.9267 64.4643 26.9267C64.4643 26.9267 65.4534 31.7244 63.7077 32.4895C60.5392 33.8773 53.4721 32.7246 53.4721 35.9377C53.4721 43.2822 58.7353 50.4002 59.8717 50.4002C62.639 50.4011 70.6694 45.7896 70.6694 38.4446Z",
    fill: "#FFDFAE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4829 105.976L49.9697 104.552L51.8666 99.6856L53.3057 101.741L51.4829 105.976Z",
    fill: "#FFECB3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2373 109.611C51.482 109.611 54.2964 107.666 54.2964 105.266C54.2964 102.867 54.9121 100.922 53.6678 100.922C52.4235 100.922 48.9956 109.611 50.2373 109.611Z",
    fill: "#9499EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallToSchedule);
export default __webpack_public_path__ + "static/media/call-to-schedule.fe4822acbeb8c07a4a62ec512b0d095b.svg";
export { ForwardRef as ReactComponent };